import React from 'react';
import './Sec4Questions.css';
import Sec3Sections from '../sec3-Sections/Sec3Sections'; 

function Sec4Questions() {
    return (
        <div className='Questions'>
              <div className='Questions-Container'>
                <Sec3Sections />
              </div>
        </div>
    );
}

export default Sec4Questions;
